//-- Copyright (c) 2021 TMT Insights Group, LLC
import styled from '@emotion/styled';
import { Button, Drawer } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { setTransferQueueDrawer } from '@/redux/slices/fileManagerSlice';
import { selectUserFullWidthMode } from '@/redux/selectors/authSelectors';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import { selectIsTransferQueueDrawerOpen } from '@/redux/selectors/fileManagerSelectors';
import PolarisIcon from '@/components/_common/PolarisIcon';
import TransferQueue from '@/components/FileManager/TransferQueue/TransferQueue';

const TransferQueueDrawer = () => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(selectIsTransferQueueDrawerOpen);
  const tableKey = useAppSelector(selectCurrentTableKey);
  const fullWidthMode = useAppSelector(selectUserFullWidthMode);
  const isFullWidth = fullWidthMode && tableKey && fullWidthMode.includes(tableKey);

  const toggleDrawer = () => dispatch(setTransferQueueDrawer(!isOpen));

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={toggleDrawer}
        startIcon={<PolarisIcon icon="swap" style={{ transform: 'rotate(90deg)' }} height={15} />}
      >
        Transfer Queue
      </Button>
      <StyledDrawer isFullWidth={+!!isFullWidth} anchor="right" open={isOpen} onClose={toggleDrawer}>
        <TransferQueue onClose={toggleDrawer} />
      </StyledDrawer>
    </>
  );
};

export default TransferQueueDrawer;

const StyledDrawer = styled(Drawer)<{ isFullWidth: number }>`
  .MuiDrawer-paper {
    background: ${({ theme }) => theme?.palette.background.default};
    ${({ isFullWidth }) =>
      !isFullWidth
        ? `
      width: 85%;
      max-width: 1800px;
    `
        : `
      width: 100%;
      max-width: unset;
    `};
  }
`;
